import makeStyles from '@material-ui/core/styles/makeStyles';

export default makeStyles(() => ({
  smallNavList: { paddingLeft: 2 },
  smallNav: { padding: 0 },
}));
